module.exports = __webpack_public_path__ + "img/summary_adsales.b6a3dd0.svg";